import { ConveresationMessage } from "./conversation-message";
import { IScheduleShift, ScheduleShift } from "./schedule/schedule-shift";

export enum MessageTypeEnum {
	UserMessage = 0,
	SystemMessage = 1,
	BirthdayMessage = 2,
}

export interface IMessageAttatchment {
	fileName: string;
	uniqueId: Guid;
}

interface IMetaData {
	type: "shift" | "attachment";
	payload: string;
}

interface IConversationValues {
	batchId: Guid;
	system: string;
	title: string;
	messageType: MessageTypeEnum;
	hasUnreadMessage: boolean;
	meta?: IMetaData;
	applicationShift?: ScheduleShift;
	attachments?: IMessageAttatchment[];
	canReply: boolean;
	subject?: Guid;
	name: string;
	image?: Guid | undefined;
	latestMessageTime: Date;
	messages: ConveresationMessage[];
}

export class Converesation implements IConversationValues {
	batchId: string;
	system: string;
	title: string;
	messageType: MessageTypeEnum;
	hasUnreadMessage: boolean;
	meta?: IMetaData;
	applicationShift?: ScheduleShift;
	attachments?: IMessageAttatchment[];
	canReply: boolean;
	subject?: string;
	name: string;
	image?: Guid;
	latestMessageTime: Date;
	messages: ConveresationMessage[];

	constructor(values: Partial<IConversationValues>) {
		this.batchId = values.batchId ?? "";
		this.system = values.system ?? "";
		this.title = values.title ?? "";
		this.messageType = values.messageType ?? MessageTypeEnum.UserMessage;
		this.hasUnreadMessage = values.hasUnreadMessage ?? false;
		this.applicationShift =
			values.meta && values.meta.type === "shift"
				? new ScheduleShift(JSON.parse(values.meta.payload) as IScheduleShift, values.system ?? "")
				: undefined;
		this.attachments =
			values.meta && values.meta.type === "attachment"
				? (JSON.parse(values.meta.payload) as IMessageAttatchment[])
				: undefined;
		this.meta = values.meta;
		this.canReply = values.canReply ?? false;
		this.subject = values.subject;
		this.name = values.name ?? "";
		this.image = values.image;
		this.latestMessageTime = new Date(values.latestMessageTime ?? 0);
		this.messages = (values.messages ?? []).map((m) => new ConveresationMessage(m));
	}
}
